import script from "./WordDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WordDetail.vue?vue&type=script&setup=true&lang=js"

import "./WordDetail.vue?vue&type=style&index=0&id=13715f1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13715f1e"]])

export default __exports__